define((require) => {
    "use strict";

    const IntegrationModel = require("editor/ui/settings/integrations/IntegrationModel");

    /**
     * Marker class for font integrations.
     *
     * @class FontIntegrationModel
     */
    return IntegrationModel.extend("FontIntegration", {});
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/FontIntegrationModel.js